import React, { useContext, useEffect, useState } from 'react';
import { Button, Col, Drawer, Form, Row } from 'antd';
import PropTypes from 'prop-types';
import LegalRepresentative from './ContentFormFields/LegalRepresentative';
import Address from './ContentFormFields/Address';
import CivilPartner from './ContentFormFields/CivilPartner';
import AddressCivilPartner from './ContentFormFields/AddressCivilPartner';
import Documents from './ContentFormFields/Documents';
import tokens from '../../../../../../../utils/tokens';
import useMobileBreakpoint from '../../../../../../../hooks/useMobileBreakpoint';
import { EnrollmentFormContext } from '../../../../../../../providers/EnrollmentFormContextProvider';
// import useEnrollmentUpdate from '../../../../../../../hooks/useEnrollmentUpdate';
// import file from '../../../../../../../utils/file';
// import DocumentTypeKey from '../../../../../../../enums/DocumentTypeKey';
import form from '../../../../../../../utils/form';

const DrawerForm = ({ visible, closeDrawer, index, title, forceRender }) => {
  const [showCivilAdressPartner, setShowCivilAdressPartner] = useState(false);
  // const [] = useEnrollmentUpdate();
  const { enrollmentForm } = useContext(EnrollmentFormContext);

  const gutter = tokens.forms.horizontalGutterInPx;
  const isMobile = useMobileBreakpoint();

  useEffect(() => {
    setShowCivilAdressPartner(
      enrollmentForm.getFieldValue(['legalRepresentatives', index, 'civilStatus']) === 'CASADO'
    );
  }, [setShowCivilAdressPartner, index]);

  const handleSubmit = async () => {
    // const formValues = enrollmentForm.getFieldsValue(true);

    // const legalRepresentatives = await Promise.all(
    //   formValues.legalRepresentatives.map(async (legalRepresentative) => {
    //     const documents = [];

    //     await Promise.all(
    //       (legalRepresentative.ciDocuments || []).map(async (uploadedFile) => {
    //         const { name, originFileObj } = uploadedFile;
    //         const base64 = await file.toBase64(originFileObj);

    //         documents.push({
    //           filename: name,
    //           base64,
    //           typeKey: DocumentTypeKey.LEGAL_REPRESENTATIVE_CI,
    //         });
    //       })
    //     );
    //     closeDrawer();

    //     return {
    //       ...legalRepresentative,
    //       documents,
    //     };
    //   })
    // );

    // const updatePayload = {
    //   legalRepresentatives,
    //   legalPerson: undefined,
    // };

    // updateEnrollment(updatePayload);
    closeDrawer();
  };

  return (
    <Drawer
      title="Documentos Personales"
      width={isMobile ? null : 720}
      onClose={() => {
        closeDrawer();
      }}
      visible={visible}
      bodyStyle={{ paddingBottom: 80 }}
      forceRender={forceRender}
    >
      {/* <Spin spinning={isLoading}> */}
      <Form
        form={enrollmentForm}
        layout="vertical"
        onFinish={handleSubmit}
        validateMessages={form.validateMessages}
      >
        <LegalRepresentative gutter={gutter} title={title} index={index} />
        <Address gutter={gutter} title="Domicilio Particular" index={index} />
        <CivilPartner
          setPartnerCivilAdress={setShowCivilAdressPartner}
          gutter={gutter}
          title="Cónyuge o conviviente civil"
          index={index}
        />
        {showCivilAdressPartner && (
          <AddressCivilPartner
            gutter={gutter}
            title="Domicilio de cónyuge o conviviente civil"
            index={index}
          />
        )}
        <Documents gutter={gutter} title="Registro de Documentos del cliente" index={index} />
        <Row gutter={[tokens.forms.horizontalGutterInPx]}>
          <Col span={12}>
            <Form.Item>
              <Button type="primary" block htmlType="button" onClick={handleSubmit}>
                Confirmar
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      {/* </Spin> */}
    </Drawer>
  );
};

DrawerForm.propTypes = {
  visible: PropTypes.bool.isRequired,
  closeDrawer: PropTypes.func.isRequired,
  index: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  forceRender: PropTypes.bool,
};

DrawerForm.defaultProps = {
  forceRender: false,
};
export default DrawerForm;
